import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Table, Column } from '../components/ui/Table';
import { Plus, Search, BadgeCheck, Ban } from 'lucide-react';
import { KYCGroupForm } from '../components/KYCGroupForm';
interface KYCGroup {
  id: string;
  groupId: string;
  name: string;
  status: 'active' | 'inactive';
}
export function KYCGroupSetup() {
  const [isCreating, setIsCreating] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  // Mock Data
  const kycGroups: KYCGroup[] = [{
    id: '1',
    groupId: 'KYC-001',
    name: 'Basic KYC',
    status: 'active'
  }, {
    id: '2',
    groupId: 'KYC-002',
    name: 'Standard KYC',
    status: 'active'
  }, {
    id: '3',
    groupId: 'KYC-003',
    name: 'Enhanced Due Diligence',
    status: 'active'
  }, {
    id: '4',
    groupId: 'KYC-004',
    name: 'Corporate KYC',
    status: 'active'
  }, {
    id: '5',
    groupId: 'KYC-005',
    name: 'High Net Worth KYC',
    status: 'active'
  }, {
    id: '6',
    groupId: 'KYC-006',
    name: 'Legacy KYC (Deprecated)',
    status: 'inactive'
  }];
  const filteredGroups = kycGroups.filter(g => g.name.toLowerCase().includes(searchQuery.toLowerCase()) || g.groupId.toLowerCase().includes(searchQuery.toLowerCase()));
  const columns: Column<KYCGroup>[] = [{
    key: 'groupId',
    label: 'KYC Group ID'
  }, {
    key: 'name',
    label: 'KYC Group Name',
    render: item => <span className="font-medium text-gray-900" data-id="element-2087">{item.name}</span>
  }, {
    key: 'status',
    label: 'Status',
    render: item => <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${item.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-2088">
          {item.status === 'active' ? <BadgeCheck className="w-3 h-3 mr-1" data-id="element-2089" /> : <Ban className="w-3 h-3 mr-1" data-id="element-2090" />}
          {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
        </span>
  }];
  if (isCreating) {
    return <KYCGroupForm onBack={() => setIsCreating(false)} onSave={() => {
      // In a real app, this would save the data
      setIsCreating(false);
    }} data-id="element-2091" />;
  }
  return <div className="space-y-8 animate-in fade-in duration-500" data-id="element-2092">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-2093">
        <div data-id="element-2094">
          <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-2095">
            KYC Group Setup
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-2096">
            Define KYC requirements and verification levels for customer
            segments.
          </p>
        </div>
        <Button size="lg" className="shadow-sm" onClick={() => setIsCreating(true)} data-id="element-2097">
          <Plus className="mr-2 h-5 w-5" data-id="element-2098" />
          Add New KYC Group
        </Button>
      </div>

      {/* Search */}
      <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm" data-id="element-2099">
        <div className="relative" data-id="element-2100">
          <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-2101" />
          <Input placeholder="Search KYC groups by ID or name..." className="pl-10 border-0 bg-gray-50 focus:bg-white transition-colors" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-2102" />
        </div>
      </div>

      {/* Table */}
      <Table columns={columns} data={filteredGroups} onRowClick={group => console.log('Clicked KYC group:', group)} keyExtractor={item => item.id} data-id="element-2103" />
    </div>;
}